// extracted by mini-css-extract-plugin
module.exports = {"noData":"Body_noData__3jdk3"};